import {
  CrmAggregateType,
  OutboxEventStatus,
} from '@rematter/frontend-lib-api-client';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type CrmOutboxEventRecord = QueryAtomResult<
  typeof crmOutboxEventsQueryAtom
>['events'][number];

export const crmOutboxEventsQueryAtom = createQueryAtomFactory(
  'auditLog.crmOutboxEvents',
  (params: {
    aggregateTypes?: CrmAggregateType[];
    aggregateId?: string;
    statuses?: OutboxEventStatus[];
    createdAtRange?: { start?: string; end?: string };
    pagination?: {
      limit: number;
      offset: number;
    };
  }) => ({
    crmOutboxEvents: {
      __args: {
        filter: {
          aggregateTypes: params.aggregateTypes,
          aggregateId: params.aggregateId,
          statuses: params.statuses,
          createdAtRange: params.createdAtRange,
        },
        pagination: params.pagination ?? { limit: 50, offset: 0 },
      },
      entries: {
        id: true,
        topic: true,
        eventName: true,
        version: true,
        metadata: {
          id: true,
          topic: true,
          eventName: true,
          aggregateId: true,
          occurredOn: true,
          organizationId: true,
          version: true,
        },
        payload: true,
        status: true,
        retryCount: true,
        lastRetry: true,
        createdBy: true,
        createdByUser: {
          id: true,
          firstName: true,
          lastName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
        limit: true,
        offset: true,
      },
    },
  }),
  {
    select: ({ crmOutboxEvents }) => ({
      total: crmOutboxEvents.page.total ?? 0,
      events: crmOutboxEvents.entries,
    }),
  },
);
